import { useState, FormEvent } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@')) { setMessage('Please enter a valid email address'); return; }
    setIsSubmitting(true);
    setMessage('');
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      const response = await fetch('https://readdy.ai/api/form/d6k7huv51pef945vq640', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString()
      });
      if (response.ok) { setMessage('Welcome to the Motion! Check your email.'); setEmail(''); }
      else setMessage('Something went wrong. Please try again.');
    } catch { setMessage('Connection error. Please try again.'); }
    finally { setIsSubmitting(false); }
  };

  return (
    <section id="community" className="relative w-full bg-gradient-to-b from-[#0a0a0a] to-[#1a1a1a] py-16 sm:py-24 md:py-32">
      <div className="w-[90%] max-w-[600px] mx-auto text-center">
        <div className="inline-block px-6 py-2 bg-white rounded-full mb-8">
          <span className="text-black text-xs sm:text-sm font-medium tracking-wider">Join The Motion</span>
        </div>
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6">Never Miss A Drop</h2>
        <p className="text-sm sm:text-base text-gray-400 font-light mb-10 sm:mb-16">
          Get exclusive access to new releases and special offers
        </p>
        <form id="newsletter-form" onSubmit={handleSubmit} className="relative" data-readdy-form>
          <div className="relative w-full h-14 sm:h-16 bg-white/5 border border-white/20 rounded-full overflow-hidden transition-all duration-300 focus-within:border-[#00d4ff] focus-within:shadow-[0_0_30px_rgba(0,212,255,0.4)]">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full h-full px-6 sm:px-8 pr-16 bg-transparent text-white text-sm sm:text-base outline-none placeholder:text-gray-500"
              disabled={isSubmitting}
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-full bg-[#00d4ff] text-white transition-all duration-300 hover:bg-[#00b8e6] disabled:opacity-50 cursor-pointer group"
            >
              <i className={`ri-arrow-right-line text-lg sm:text-xl transition-transform duration-300 group-hover:translate-x-1 ${isSubmitting ? 'animate-spin' : ''}`}></i>
            </button>
          </div>
        </form>
        {message && (
          <p className={`mt-4 sm:mt-6 text-sm ${message.includes('Welcome') ? 'text-[#00d4ff]' : 'text-red-400'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}
